import styled from '@emotion/styled';
import { Card, CardHeader, IconButton, Typography, blue, grey, tokens } from '@galaxy-react/core';

export const CardStyled = styled(Card)({
  backgroundColor: tokens.colorNeutralCardBackground,
});

export const HoverContentStyled = styled(CardHeader)({
  '& .fui-CardHeader__header': {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gridRowStart: 'span 2',
    flex: '1',
    minWidth: 0,
  },

  '& .fui-CardHeader__image': {
    height: '100%',
    marginRight: tokens.spacingVerticalXXL,
  },

  '& .fui-CardHeader__action': {
    marginLeft: '56px',
    width: '325px',
  },
});

export const HoverHeaderStyled = styled('div')({
  display: 'flex',
  width: '100%',
  alignItems: 'center',
});

export const HeadingStyled = styled(Typography)({
  fontWeight: tokens.fontWeightSemibold,
  color: blue[700],
  whiteSpace: 'nowrap',
  '&.fui-Text': {
    color: blue[700],
  },
});

export const HoverIconsStyled = styled('div')({
  display: 'flex',
  gap: tokens.spacingVerticalXS,
  marginLeft: 'auto',
});

export const HeaderActionStyled = styled('div')({
  display: 'flex',
  gap: tokens.spacingVerticalXXL,
  width: '100%',
  justifyContent: 'flex-end',
});

export const DateStyled = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '90px',
});

export const StarPlaceholderStyled = styled('div')({
  width: '16px',
  height: '16px',
  margin: `0 ${tokens.spacingVerticalXS}`,
});

export const CardBodyContainerStyled = styled('div')({
  display: 'flex',
  gap: tokens.spacingVerticalM,
  alignItems: 'center',
});

export const ChipsWrapperStyled = styled('div')({
  display: 'flex',
  marginTop: tokens.spacingHorizontalS,
  height: 'min-content',
  gap: tokens.spacingVerticalS,
});

export const DescriptionStyled = styled(Typography)({
  fontSize: '12px',
  color: grey[800],
  marginTop: tokens.spacingHorizontalS,
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  lineHeight: 'normal',
  '&.fui-Text': {
    color: grey[800],
  },
});

export const HeadingWrapperStyled = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
});

export const FirstColImgStarStyled = styled('div', {
  shouldForwardProp: (prop) => prop !== 'alignment',
})<{ alignment?: boolean }>(({ alignment }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: alignment ? 'flex-start' : 'center',
}));

export const PopoverChipsWrapperStyled = styled('div')({
  display: 'flex',
  padding: '16px',
  gap: tokens.spacingVerticalS,
});

export const PopoverListStyled = styled('ul')({
  padding: `0 ${tokens.spacingVerticalL}`,
  margin: '0',
  listStyle: 'none',
});

export const PopoverLiStyled = styled('li')({
  display: 'flex',
  '&:first-of-type': {
    paddingTop: '16px',
  },
  '&:last-child': {
    paddingBottom: '16px',
  },
  paddingTop: '8px',

  gap: '16px',
});

export const PopoverTypographyStyled = styled('h4')({
  margin: '16px 0 0',
  color: blue[700],
});

export const PopoverContentStyled = styled('div')({
  color: grey[800],
  gap: tokens.spacingVerticalL,
  display: 'flex',
  alignItems: 'center',
  svg: {
    color: blue[700],
  },
});

export const ActionAvatarWrapperStyled = styled('div')({
  display: 'flex',
  gap: tokens.spacingVerticalXS,
  alignItems: 'center',
});

export const MenuIconButtonStyled = styled(IconButton)({
  '&.fui-Button': {
    width: 24,
    height: 24,
    svg: {
      color: grey[400],
    },
  },
});
